import { ConfigProvider, theme } from 'antd'
// https://rjsf-team.github.io/react-jsonschema-form/docs/api-reference/themes/antd/uiSchema#using-antd-v5-theme
import 'antd/dist/reset.css'
import { grey, orange } from '@ant-design/colors'

export const customTheme = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: orange[5],
    colorBgContainer: grey[7]
  }
}

export const backgroundColor = '#262626'

export function AntDesignProvider(props: any) {
  const { children } = props
  return <ConfigProvider theme={customTheme}>{children}</ConfigProvider>
}
